import { useState } from "react";
import { Box } from "@mui/material";

import GinoHeader from "../../components/GinoHeader";
import { useGetGinoCredits } from "../../api/queries/ginoCredits";

import { GinoHomeChat } from "./GinoHomeChat";
import { GinoHomeQuickActionsSection } from "./GinoHomeQuickActionsSection";

const GinoHomePage = () => {
  const { data: ginoCredits, isLoading: isLoadingGinoCredits, error: errorGinoCredits } = useGetGinoCredits();

  const [openCreditLeftModal, setOpenCreditLeftModal] = useState(false);
  const handleOpenCreditLeftModal = () => setOpenCreditLeftModal(true);
  const handleCloseCreditLeftModal = () => setOpenCreditLeftModal(false);

  return (
    <Box sx={styles.container}>
      <GinoHeader
        ginoCredits={ginoCredits}
        isLoadingGinoCredits={isLoadingGinoCredits}
        errorGinoCredits={errorGinoCredits}
        openCreditLeftModal={openCreditLeftModal}
        handleOpenCreditLeftModal={handleOpenCreditLeftModal}
        handleCloseCreditLeftModal={handleCloseCreditLeftModal}
      />
      <Box sx={styles.mainContainer}>
        <GinoHomeChat
          ginoCredits={ginoCredits}
          isLoadingGinoCredits={isLoadingGinoCredits}
          handleOpenCreditLeftModal={handleOpenCreditLeftModal}
        />
        <GinoHomeQuickActionsSection />
      </Box>
    </Box>
  );
};

export default GinoHomePage;

const styles = {
  container: {
    width: "100%",
    background: "var(--background-surface-default, #FFF)",
    padding: { xs: "0", md: "32px" },
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  mainContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    padding: { xs: "40px 0", sm: "150px 30px", md: "150px 80px" },
  },
};
